import { render, staticRenderFns } from "./ViolationForm.vue?vue&type=template&id=5d501c9d&"
import script from "./ViolationForm.vue?vue&type=script&lang=js&"
export * from "./ViolationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports